import React from "react";

import { Box, BoxProps } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  container: {
    overflow: "hidden",
    overflowY: "auto",
    height: "100%",
  },
}));

interface VerticalScrollContainerProps extends BoxProps {
  children: React.ReactNode;
}

export const VerticalScrollContainer: React.FC<VerticalScrollContainerProps> =
  ({ children, ...props }) => {
    const { classes } = useStyles();

    return (
      <Box className={classes.container} {...props}>
        {children}
      </Box>
    );
  };
